import { render, staticRenderFns } from "./SubmissionDetailFilter.vue?vue&type=template&id=4d50a492&scoped=true"
import script from "./SubmissionDetailFilter.vue?vue&type=script&lang=js"
export * from "./SubmissionDetailFilter.vue?vue&type=script&lang=js"
import style0 from "./SubmissionDetailFilter.vue?vue&type=style&index=0&id=4d50a492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50a492",
  null
  
)

export default component.exports